<template>
  <div v-if="this.webShopOrder != null" class="container justify-content-center mt-5 webshop-payment-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 mt-5">
        <h3>
          {{ $t(LangConstants.your_order_summary_heading) }}
        </h3>
        <div class="row">
          <div class="col-md-12">
            <webshop-product-item :event="this.event" :title="product.name" :imgUrl="product.image ? product.image : ''" :subPeriod="this.paymentRecurringPeriod" :total="this.totalAmount" :description="product.description" :unitPrice="(this.unitPrice = !0 ? this.unitPrice : '')" :quantity="this.quantity"> </webshop-product-item>

            <div class="row">
              <div class="col-md-12">
                <div class="mt-5">
                  <my-button fa="bars" :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit" @onClick="payByCard"></my-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <stripe-checkout ref="checkoutRef" mode="subscription" :pk="publishableKey" :line-items="lineItems" :success-url="successURL" :cancel-url="cancelURL" :session-id="sessionId" @loading="(v) => (loading = v)" />
  </div>
</template>

<style lang="scss" scoped>
.webshop-payment-page {
  margin-top: 20px;
}
</style>

<script>
/**
 * Webshop Payment Page
 */

import Common from "../../../../functions/index";
import Constants from "../../../../constants/index";

import WebshopProductItem from "../../../../components/atoms/WebshopProductItem.vue";
import "../../../../assets/scss/companypayment.scss";
import "../../../../assets/scss/stepper.scss";
import MyButton from "../../../../components/atoms/Button.vue";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { store } from "../../../../store/store";

export default {
  name: "webshop-payment",
  async beforeCreate() {},

  async created() {
    this.paymentId = this.$route.params.paymentId;
    this.instanceId = this.$route.params.instanceId;

    await this.$store
      .dispatch("getpendingWebshopPayment", {
        id: this.paymentId,
        instance_id: this.instanceId,
      })
      .then((wsp) => {
        wsp = wsp["data"];
        this.webShopOrder = wsp;
        this.product = wsp["course"];
        this.quantity = wsp["webshop_payment"]["quantity"];

        this.stripeCheckoutSessionPayload = {
          params: {
            mode: "payment",
            success_url: "",
            cancel_url: "",
            payment_intent_data: {
              application_fee_amount: 0,
              receipt_email: "",
            },
            line_items: [],
            automatic_tax: {
              enabled: true,
            },
            metadata: {
              //   form_firstName: this.stateStep2.firstName,
              //   form_lastName: this.stateStep2.lastName,
              //   form_registerEmail: this.stateStep2.registerEmail,
              //   form_phone: this.stateStep2.phone,
              //   form_sendmarketingemails: this.stateStep2.sendmarketingemails,
              //   form_courseid: this.$route.params.courseId,
              //   form_instance_id: this.$route.params.instanceId,
              //   form_userType: this.userType,
              //   form_organizationName: this.stateStep2.organizationName,
              //   form_organizationNumber: this.stateStep2.organizationNumber,
              //   product: null,
            },
          },
          options: {
            stripe_account: "",
          },
        };

        this.stripeInvoiceItemPayload = {
          customer: "",
          amount: "",
          currency: "",
          StripeAccount: "",
        };

        this.stripeInvoicePayload = {
          customer: "",
          application_fee_amount: "",
        };

        this.productPricing = {
          recurring: { interval: "one-time" },
          currency: wsp["webshop_payment"]["currency"],
          unit_amount: wsp["webshop_payment"]["total"],
        };

        // this.webshopId = result.data.id;

        this.stripeCheckoutSessionPayload.params.metadata.product = wsp["course"]["name"];

        this.stripeCheckoutSessionPayload.params.line_items.push({
          price_data: {
            tax_behavior: "inclusive",
            currency: wsp["webshop_payment"]["currency"],
            product_data: {
              name: this.product.name,
            },
            unit_amount: parseFloat(  (wsp["webshop_payment"]["total"] / wsp["webshop_payment"]["quantity"] )    ) * 100,
          },
          quantity: wsp["webshop_payment"]["quantity"],
        });

        this.stripeCheckoutSessionPayload.options.stripe_account = wsp["stripe_connect_active_account"]["account_id"];
        this.stripeCheckoutSessionPayload.params.success_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/success/{CHECKOUT_SESSION_ID}/card/" + wsp["stripe_connect_active_account"]["account_id"];
        this.stripeCheckoutSessionPayload.params.cancel_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/failed/{CHECKOUT_SESSION_ID}/card/" + wsp["stripe_connect_active_account"]["account_id"];

        this.stripeInvoiceItemPayload.amount = parseFloat(this.product.price) * 100;
        this.stripeInvoiceItemPayload.currency = this.product.currency;
        this.stripeInvoiceItemPayload.StripeAccount = wsp["stripe_connect_active_account"]["account_id"];
        this.stripeInvoicePayload.StripeAccount = wsp["stripe_connect_active_account"]["account_id"];

        this.$store
          .dispatch("getInstanceSettingsFiltered", {
            names: ["webshop_tranfer_fee_rate"],
            instance_id: this.$route.params.instanceId,
          })
          .then((result) => {

            this.applicationFeeRate = result.data.webshop_tranfer_fee_rate;
            const applicationFeeAmount = Common.calculateApplicationFee(this.applicationFeeRate, wsp["webshop_payment"]["total"]);

            this.stripeCheckoutSessionPayload.params.payment_intent_data.application_fee_amount = applicationFeeAmount;
            this.stripeInvoicePayload.application_fee_amount = applicationFeeAmount;
          });
      });

  },
  setup() {
    return {
      loading: false,
      successURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/success",
      cancelURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/failed",
    };
  },
  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    return {
      lineItems: [
        {
          price: null,
          quantity: 1,
        },
      ],

      product: [],
      stripeCheckoutSessionPayload: {},
      stripeInvoiceItemPayload: {},
      webshopId: null,
      stripeInvoicePayload: {},
      productPricing: null,
      unitPrice: "",
      quantity: 0,
      sessionId: "",
      discountPercentage: 0,
      discountedPrice: 0,
      instanceId: null,
      paymentId: null,
      event: {},
      applicationFeeRate: 0,
      webShopOrder: null,
    };
  },

  methods: {
    async processLogin() {},

    async ProcessRegister() {},

    async payByCard() {

      this.stripeCheckoutSessionPayload.params.payment_intent_data.receipt_email = this.$store.state.currentAbandonedOrder["buyer"]["email"];
      this.stripeCheckoutSessionPayload.params.customer_email = this.$store.state.currentAbandonedOrder["buyer"]["email"];

      this.$store.dispatch("createStripeCheckout", this.stripeCheckoutSessionPayload).then((session) => {
        if (session.success == true) {
          this.sessionId = session.data.id;
          this.cacheFormData(session.data.id);
          window.location.href = session.data.url;
        } else {
          this.$fire({
            title: this.$t(Constants.common_error_title),
            text: this.$t(Constants.please_try_again_text),
            type: "error",
            html: "",
          });
        }
      });
    },

    async processInternalInvoice() {
      const id = Common.randomId();
      this.cacheFormData(id);

      this.$router.push({
        path: `/company-account/webshop/purchase/subscription/success/${id}/invoice_internal/null`,
      });
    },


    cacheFormData(key) {
      let formData = {};

      formData = {
        instance_id: this.$route.params.instanceId,
        webshop_payment_id: this.$store.state.currentAbandonedOrder["webshop_payment"]["id"],
        product: {
          webshopId: this.webshopId,
          amount: this.$store.state.currentAbandonedOrder["webshop_payment"]["total"],
          event_id: this.$store.state.currentAbandonedOrder["course_event"] ? this.$store.state.currentAbandonedOrder["course_event"]['id'] : null,
          quantity: this.$store.state.currentAbandonedOrder["webshop_payment"]["quantity"],
          unit_price:  this.$store.state.currentAbandonedOrder["webshop_payment"]["total"] / this.$store.state.currentAbandonedOrder["webshop_payment"]["quantity"],
          currency: this.$store.state.currentAbandonedOrder["webshop_payment"]["currency"],
          productName: this.$store.state.currentAbandonedOrder["course"]["name"],
        },
      };
 
      Common.setinLocalStorage(key, formData);
    },

    incrementStep() {
      // this.currentStep++;
      // this.$root.$emit("webshop-payment-wizard-step", this.currentStep);
    },

    calculateDiscount() {
      this.discountedPrice = ((this.discountPercentage / 100) * this.product.price).toFixed(2);
    },

    getDefaultAmountValue() {
      let currency = this.productPricing != null && this.productPricing.currency ? Common.toUpperCase(this.productPricing.currency) : "";
      return "00.00 " + currency;
    },
  },
  computed: {
    webShopOrder_() {
      return this.webShopOrder;
    },
    customers() {
      return this.$store.getters.allCustomers;
    },

    totalAmount() {
      if (this.productPricing != null) {
        return Common.formatMoney(this.productPricing.unit_amount, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
    paymentRecurringPeriod() {
      if (this.productPricing != null) {
        return this.productPricing.recurring ? Common.getIntervalByNoun(this.productPricing.recurring.interval) : "";
      }
      return "";
    },

    LangConstants() {
      return Constants;
    },

    marketingConsentHelperText() {
      return "(" + this.$t(Constants.marketing_consent_helper_text) + ")";
    },

    discountPrice() {
      if (this.discountPercentage != 0) {
        this.calculateDiscount();
        return Common.formatMoney(this.discountedPrice, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },

    totalAmountWithDiscount() {
      if (this.productPricing != null) {
        let total = this.productPricing.unit_amount - this.discountedPrice;
        return Common.formatMoney(total, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
  },

  components: {
    WebshopProductItem,
    MyButton,
    StripeCheckout,
  },
};
</script>
